/**
 * AccessDeniedNotice (DNKADM-0433) — the shared "locked" state for a `403`: a headline,
 * the reason (and who to ask), and deliberately NO Try again (a retry can never work).
 */
import { Box, Typography } from '@mui/material';
import { ACCESS_DENIED_TITLE } from '@/components/accessCopy';

export function AccessDeniedNotice({ message }: { message: string | null }) {
  return (
    <Box role="alert" sx={{ mt: 2 }}>
      <Typography variant="h3" component="h2">
        {ACCESS_DENIED_TITLE}
      </Typography>
      {message ? (
        <Typography sx={{ mt: 0.5, maxWidth: 520 }}>{message}</Typography>
      ) : null}
    </Box>
  );
}
